import { validatedInputFieldFactory } from './validatedInputFieldFactory';

const ValidatedTextArea = validatedInputFieldFactory('textarea');

export default ValidatedTextArea;
